module.exports = __webpack_public_path__ + "img/ic_euro_2.eb211540.svg";